import { chain } from 'lodash';
import { load } from 'cheerio';
export const extractValuesFromHtml = (html, mapper) => chain(html)
    .map((h) => load(h))
    .map(mapper)
    .flatten()
    .uniq()
    .value();
//# sourceMappingURL=extract-values-from-html.js.map